<template>
    <v-card v-if="survey">
        <v-card-text class="text-center">
            <v-window
                v-model="window"
                touchless
                @change="watchSurveyEnd"
            >
                <v-window-item
                    v-for="content in survey.contents"
                    :key="content.id"
                >
                    <div class="headline mb-2">
                        {{ content.question.title }}
                    </div>

                    <component
                        :is="content.component"
                        :question="content.question"
                        @input="responseToQuestion"
                        @skip="skipQuestion"
                    ></component>
                </v-window-item>

                <v-window-item>
                    <div class="d-flex justify-center align-center">
                        <div class="mr-4">
                            <v-icon large>mdi-thumb-up</v-icon>
                        </div>
                        <div>
                            <div class="subtitle-1">
                                Terimakasih sudah membantu kami untuk #Gobeyond
                            </div>
                        </div>
                    </div>
                </v-window-item>
            </v-window>
        </v-card-text>
    </v-card>
</template>

<script>
import ReactionRange from './Survey/ReactionRange.vue'
import ShortAnswer from './Survey/ShortAnswer.vue'
import LongAnswer from './Survey/LongAnswer.vue'
import SingleSelection from './Survey/SingleSelection.vue'
import MultipleSelection from './Survey/MultipleSelection.vue'

const TYPE_DICTIONARY = {
    reaction_range: ReactionRange,
    short_answer: ShortAnswer,
    long_answer: LongAnswer,
    single_selection: SingleSelection,
    multiple_selection: MultipleSelection,
}

export default {
    data: () => ({
        survey: null,
        window: null,
    }),

    watch: {
        window() {
            this.watchSurveyEnd()
        },
    },

    computed: {
        activeQuestionId() {
            return this.survey.contents[this.window].question.uuid
        },
        surveyEndStorageKey() {
            return `survey_completed_${this.$store.get(
                'enrollment/selected@id'
            )}`
        },
    },

    async created() {
        if (localStorage.getItem(this.surveyEndStorageKey)) {
            return
        }

        const response = await this.$apiv2.get('survey')

        if (!response.data) {
            return
        }
        this.survey = {
            ...response.data,
            contents: response.data.contents.map((content) => ({
                ...content,
                component: TYPE_DICTIONARY[content.question.typeString],
            })),
        }

        const lastUnrespondedQuestionIndex = this.survey.contents.findIndex(
            (content) => content.question.responses.length == 0
        )
        if (lastUnrespondedQuestionIndex != -1) {
            this.window = lastUnrespondedQuestionIndex
        } else {
            this.survey = null
            localStorage.setItem(this.surveyEndStorageKey, true)
        }
    },

    methods: {
        responseToQuestion(value) {
            this.$apiv2.post(
                `survey-question/${this.activeQuestionId}/response`,
                { value }
            )
            this.window++
        },
        skipQuestion() {
            this.$apiv2.post(`survey-question/${this.activeQuestionId}/skip`)
            this.window++
        },
        watchSurveyEnd() {
            if (this.window == this.survey.contents.length) {
                localStorage.setItem(this.surveyEndStorageKey, true)
            }
        },
    },
}
</script>
